
(function(){
  "use strict";
  var P = window.PATEKA = window.PATEKA || {};

  P.SCHOOLS = ["Bayswater South Primary School","Berwick Lodge Primary School","Boronia Heights Primary School","Box Hill North Primary School","Burwood East Primary School","Camberwell South Primary School","Doncaster Primary School","Glendal Primary School","Glenferrie Primary School","Grayling Primary School","Heany Park Primary School","Holy Family Primary School","Mitcham Primary School","Mount Pleasant Road Primary School","Mount Waverley Heights Primary School","Rangeview Primary School","Roberts McCubbin Primary School","Syndal South Primary School","Thomas Mitchell Primary School","Wattle Park Primary School","Whitehorse Primary School"];

  
  P.SCHOOL_LINKS = {
    "Grayling Primary School":               "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195722",
    "Camberwell South Primary School":       "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195789",
    "Thomas Mitchell Primary School":        "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195831",
    "Heany Park Primary School":             "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195618",
    "Bayswater South Primary School":        "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195890",
    "Burwood East Primary School":           "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195940",
    "Mount Waverley Heights Primary School": "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97195997",
    "Roberts McCubbin Primary School":       "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196032",
    "Box Hill North Primary School":         "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196067",
    "Holy Family Primary School":            "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196108",
    "Mitcham Primary School":                "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196130",
    "Glenferrie Primary School":             "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196154",
    "Boronia Heights Primary School":        "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196202",
    "Whitehorse Primary School":             "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196243",
    "Syndal South Primary School":           "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196305",
    "Glendal Primary School":                "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196349",
    "Berwick Lodge Primary School":          "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196405",
    "Wattle Park Primary School":            "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196453",
    "Doncaster Primary School":              "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196490",
    "Mount Pleasant Road Primary School":    "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196520",
    "Rangeview Primary School":              "https://app.acuityscheduling.com/schedule.php?owner=28500244&appointmentType=97196679"
  };

  
  P.base = function(s){ return s.toLowerCase().replace(" primary school","").replace(" school",""); };
  P.findHit = function(q){
    q = String(q || "").trim().toLowerCase();
    return P.SCHOOLS.filter(function(s){
      var b = P.base(s);
      return s.toLowerCase().indexOf(q) !== -1 || b.indexOf(q) !== -1 || q.indexOf(b) !== -1;
    })[0];
  };

  
  P.attachFinder = function(inp, list, o){
    o = o || {};
    var prefix = o.idPrefix || (list.id + "-");
    var activeIdx = -1;
    function options(){ return list.querySelectorAll('[role="option"]'); }
    function closeList(){
      list.classList.remove("open");
      list.innerHTML = "";
      inp.setAttribute("aria-expanded","false");
      inp.removeAttribute("aria-activedescendant");
      activeIdx = -1;
    }
    function setActive(idx){
      var opts = options();
      if (!opts.length) return;
      if (idx < 0) idx = opts.length - 1;
      if (idx >= opts.length) idx = 0;
      Array.prototype.forEach.call(opts, function(el, i){ el.setAttribute("aria-selected", i === idx ? "true" : "false"); });
      activeIdx = idx;
      inp.setAttribute("aria-activedescendant", opts[idx].id);
      opts[idx].scrollIntoView({block:"nearest"});
    }
    function pickOther(){
      inp.value = o.otherValue || "Other school";
      closeList();
      if (o.onOther) o.onOther();
    }
    function pick(name){
      if (o.otherLabel && name === o.otherLabel) { pickOther(); return; }
      inp.value = name;
      closeList();
      if (o.onPick) o.onPick(name);
    }
    function renderMatches(q){
      list.innerHTML = "";
      activeIdx = -1;
      inp.removeAttribute("aria-activedescendant");
      if (q.length < 2) { list.classList.remove("open"); inp.setAttribute("aria-expanded","false"); return; }
      var matches = P.SCHOOLS.filter(function(s){
        return s.toLowerCase().indexOf(q) !== -1 || P.base(s).indexOf(q) !== -1;
      }).slice(0, 6);
      matches.forEach(function(s, i){
        var li = document.createElement("li");
        li.setAttribute("role","option");
        li.id = prefix + i;
        li.setAttribute("aria-selected","false");
        var dot = document.createElement("span"); dot.className = "dot";
        li.appendChild(dot);
        li.appendChild(document.createTextNode(s));
        li.addEventListener("mousedown", function(e){ e.preventDefault(); }); 
        li.addEventListener("click", function(){ pick(s); });
        list.appendChild(li);
      });
      if (o.otherLabel) { 
        var lo = document.createElement("li");
        lo.setAttribute("role","option"); lo.id = prefix + "other"; lo.className = "other";
        lo.setAttribute("aria-selected","false");
        var od = document.createElement("span"); od.className = "dot"; lo.appendChild(od);
        lo.appendChild(document.createTextNode(o.otherLabel));
        lo.addEventListener("mousedown", function(e){ e.preventDefault(); });
        lo.addEventListener("click", pickOther);
        list.appendChild(lo);
      }
      var open = matches.length > 0 || !!o.otherLabel;
      list.classList.toggle("open", open);
      inp.setAttribute("aria-expanded", open ? "true" : "false");
    }
    inp.addEventListener("input", function(){
      renderMatches(inp.value.trim().toLowerCase());
      if (o.onInput) o.onInput();
    });
    inp.addEventListener("keydown", function(e){
      var open = list.classList.contains("open");
      if (e.key === "ArrowDown") {
        if (!open) renderMatches(inp.value.trim().toLowerCase());
        if (list.classList.contains("open")) { e.preventDefault(); setActive(activeIdx + 1); }
      } else if (e.key === "ArrowUp") {
        if (open) { e.preventDefault(); setActive(activeIdx - 1); }
      } else if (e.key === "Home" && open && activeIdx > -1) {
        e.preventDefault(); setActive(0);
      } else if (e.key === "End" && open && activeIdx > -1) {
        e.preventDefault(); setActive(options().length - 1);
      } else if (e.key === "Enter") {
        if (open && activeIdx > -1) { e.preventDefault(); pick(options()[activeIdx].textContent); }
        
      } else if (e.key === "Escape") {
        if (open) { e.preventDefault(); closeList(); }
      } else if (e.key === "Tab" && open) {
        closeList();
      }
    });
    document.addEventListener("click", function(e){
      if (!list.contains(e.target) && e.target !== inp) closeList();
    });
    return { close: closeList, render: renderMatches };
  };
})();
